import Curl from '$common/utils/curl/browser-curl';
import AppCurl from '$common/utils/curl/app-curl';
import { isWownowApp } from '$common/utils/common'
import UrlModules from '$common/utils/curl/browser-curl/url-modules';
import { gateway_web as pix } from './api-pix';
const appgatewayHost = new UrlModules({ module: 'appgateway' });
let _appgatewayHost = appgatewayHost.host.replace('//h5', '//appgateway')
const defaultCurl = (params, url, config) => new Curl().curl(params, `${_appgatewayHost}/${pix}/${url}`, config);
const defaultAppCurl = (params, url, config) => new AppCurl().curl(params, `/${url}`, config);

/**
 * 标准埋点
 * @param {*} params
 */
export const warehouseCollectionSaveStandardCollectionData = (params, config) => {
  if (window?.ssrConfig?.routerConfig?.short?.shortID) {
    for (const e of params.standardCollectionDatas) {
      e.ext = e?.ext ?? {};
      e.ext.shortID = window.ssrConfig.routerConfig.short.shortID;
    }
  }
  return defaultCurl(params, `warehouse/collection/saveStandardCollectionData.do`, config)
};

/**
 * 其他埋点
 * @param {*} params
 * @param {*} config
 * @returns
 */
export const warehouseCollectionSaveOtherCollectionData = (params, config) => {
  console.log('warehouseCollectionSaveOtherCollectionData params: ', params)
  if (window?.ssrConfig?.routerConfig?.short?.shortID) {
    for (const e of params.otherCollectionDatas) {
      e.ext = e?.ext ?? {};
      e.ext.shortID = window.ssrConfig.routerConfig.short.shortID;
    }
  }
  if (isWownowApp) return defaultAppCurl(params, `warehouse/collection/saveOtherCollectionData.do`, config);
  return defaultCurl(params, `warehouse/collection/saveOtherCollectionData.do`, config);
}
